import { futureValueAnnualLumpsum } from "../../engine/calculations";

const fvAnnualLumpsumConfig = {
  key: "fv-annual-lumpsum",
  title: "Future Value of Annual Lumpsum",
  category: "Growth",
  description: "See what investing a fixed amount once every year grows into.",
  fields: [
    { key: "annualAmount", label: "Annual investment amount", type: "currency", default: 1_00_000, min: 1000, max: 1_00_00_00_000, help: "The amount you invest once each year." },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Investment period (years)", type: "number", default: 10, min: 1, max: 40 },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [
      { key: "invested", label: "Invested", colorVar: "--muted" },
      { key: "value", label: "Value", colorVar: "--gold" },
    ],
  },
  compute(values) {
    const annualAmount = Number(values.annualAmount) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const futureValue = futureValueAnnualLumpsum(annualAmount, annualRate, years);
    const totalInvested = annualAmount * years;

    const series = [];
    for (let y = 1; y <= years; y++) {
      series.push({ year: y, invested: annualAmount * y, value: futureValueAnnualLumpsum(annualAmount, annualRate, y) });
    }

    return {
      headline: { label: "Future Value", value: futureValue },
      breakdown: [
        { label: "Total Invested", value: totalInvested },
        { label: "Estimated Gains", value: futureValue - totalInvested },
      ],
      series,
    };
  },
};

export default fvAnnualLumpsumConfig;
